import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import formatPrice from "../lib/formatPrice";
// import { recommendClient } from '@algolia/recommend';
import axios from "axios";
import ProductCard7 from "./ProductCard7";
import { XBlock, XMasonry } from "react-xmasonry";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useInView } from "react-intersection-observer";
import Skeleton from "./Skeleton";
import useUserDataStore from "../StatesStore/UserData";
import { collection, doc, getDoc, getDocs, limit, orderBy, query, startAfter, where } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { UserAuth } from "../Context";
import ShoppingListPostCard from "../UserPosts/ShopPost/ShoppingListPostCard";
import ShareMenu2 from "../components/ShareMenu2";
import AddOrRemoveLike from "./AddOrRemoveLike";
import useActiveBrandsStore from "../StatesStore/ActiveBrands";
import { getBrandDetails } from "../lib/getBrandDetails";
import AddToList from "../components/AddToList";
import ColorSelector from "../Experiments/colorDisplay";
import Slider from "react-slick";
import ProductCard8 from "./ProductCard8";
import AddToFavorites from "../UserProfile/ProfileShoppingList/AddToFavorites";
import ProductCardBottom from "./ProductCardBottom";
import AddToChat3 from "../components/AddToChat3";
import LoadingSpinner from "../UserProfile/LoadingSpinner";
import ShoppingListPostCard2 from "../UserPosts/ShopPost/ShoppingListPostCard2";
import { useErrorBoundary } from "react-error-boundary";
import useRestoreScrollPositionStore from "../StatesStore/RestoreScrollPosition";
import GoogleAdCardMobile from "../NewsFeed/GoogleAdCardMobile";
import GoogleAdCard4 from "../NewsFeed/GoogleAdCard4";

function SimilarProducts() {
  const location = useLocation();
  const { showBoundary } = useErrorBoundary();
  const product = location.state?.product;
  const { id } = useParams();
  const [likeCount, setLikeCount] = useState(product?.likes);
  const [brandData, setBrandData] = useState(null);
  const [currentProduct, setCurrentProduct] = useState(product); // New state for the product
  const activeBrands = useActiveBrandsStore((state) => state.activeBrands);
  const [loading, setLoading] = useState(!product); // Loading state
  const isSmallScreen = window.innerWidth < 768;
  const navigate = useNavigate();
   const isScrollRestored = useRef(false);
  const { setScrollPosition, getPosition } = useRestoreScrollPositionStore();
  const currentUrl = location.pathname + location.search;

  const PrevArrow = ({ style, onClick }) => {
    return (
      <div

        style={{
          ...style,
          fontSize: "24px",
          zIndex: 1,
          left: "1%",
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          width: "30px",
          height: "30px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#FFFFFF",
          opacity: 0.6,
          borderRadius: "4px",
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        <span
          className="carousel-control-prev-icon"
          style={{ filter: "brightness(0.1)", width: "10px", height: "10px" }}
        ></span>
      </div>
    );
  };

  const NextArrow = ({ style, onClick }) => {
    return (
      <div
        style={{
          ...style,
          backgroundColor: "#FFFFFF",
          fontSize: "24px",
          zIndex: 1,
          right: "1%",
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          width: "30px",
          height: "30px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "4px",
          opacity: 0.6,
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        <span
          className="carousel-control-next-icon"
          style={{ filter: "brightness(0.1)", width: "10px", height: "10px" }}
        ></span>
      </div>
    );
  };

  // Slider Settings
  const settings = {
    speed: 500,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    swipe: true,
    nextArrow: currentProduct?.secondaryImages?.length > 0 ? <NextArrow /> : null,
    prevArrow: currentProduct?.secondaryImages?.length > 0 ? <PrevArrow /> : null,
  };

  const fetchProductById = async (productId) => {
    try {
      setLoading(true);
      // Replace with your actual firestore query
      const productRef = doc(db, "products", productId);
      const productSnap = await getDoc(productRef);

      if (productSnap.exists()) {
        setCurrentProduct(productSnap.data());
        setLikeCount(productSnap.data().likes);
      } else {
        console.log("No such product!");
      }
    } catch (error) {
      console.error("Error fetching product:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchBrandData = async (productData) => {
    try {
      if (!productData?.supplier || !activeBrands) return;

      const result = await getBrandDetails(productData.supplier, activeBrands);
      setBrandData(result);
    } catch (error) {
      console.error("Error getting brand data:", error);
    }
  };

  useEffect(() => {
    // This handles the initial load and ID changes
    window.scrollTo({ top: isSmallScreen ? 48 : 0, behavior: "instant" });
  }, [loading]);

  useEffect(() => {
    // If no product in state but we have an ID, fetch from Firestore
    if (!product && id) {
      fetchProductById(id);
    } else {
      setCurrentProduct(product);
    }
  }, [product, id]);

  useEffect(() => {
    if (currentProduct) {
      fetchBrandData(currentProduct);
    }
  }, [currentProduct, activeBrands]);

  const [recommendationsLoading, setRecommendationsLoading] = useState(false);
  const { ref: loadMoreRef, inView: loadMoreView } = useInView({
    threshold: 0.1,
  });
  const userData = useUserDataStore((state) => state.userData);
  const { user } = UserAuth();
  // Fetch similar product recommendations
  // const [similarProducts, setSimilarProducts] = useState([]);
  const getFavoriteCategories = () => {
    if (!userData?.favCategories) return { subCategories: [], subSubCategories: [] };

    const subCategories = [];
    const subSubCategories = [];

    userData.favCategories.forEach(category => {
      if (category.subCategory) subCategories.push(category.subCategory);
      if (category.subSubCategory) subSubCategories.push(category.subSubCategory);
    });

    return {
      subCategories: [...new Set(subCategories)], // Remove duplicates
      subSubCategories: [...new Set(subSubCategories)] // Remove duplicates
    };
  };

  const fetchShoppingListPosts = async ({ pageParam = null }) => {
    try {
      const { subSubCategories } = getFavoriteCategories();

      let postsQuery = query(
        collection(db, "posts"),
        where("postType", "==", "shoppingList"),
        orderBy("dateCreated", "desc"),
        limit(1)
      );

      if (subSubCategories?.length > 0) {
        postsQuery = query(
          postsQuery,
          where("subSubCategory", "array-contains-any", subSubCategories)
        );
      }

      if (pageParam) {
        postsQuery = query(postsQuery, startAfter(pageParam));
      }

      const postsSnapshot = await getDocs(postsQuery);
      const posts = postsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        isShoppingList: true
      }));

      return {
        posts,
        lastVisible: postsSnapshot.docs[postsSnapshot.docs.length - 1]
      };
    } catch (error) {
      console.error("Error fetching shopping list posts:", error);
      return { posts: [], lastVisible: null };
    }
  };
  const {
    data: shoppingPosts,
    fetchNextPage: fetchNextShoppingPosts,
    hasNextPage: hasNextShoppingPage,
    isFetchingNextPage: isFetchingNextShoppingPage
  } = useInfiniteQuery({
    queryKey: ['shoppingPosts', user?.uid],
    queryFn: fetchShoppingListPosts,
    getNextPageParam: (lastPage) => lastPage.lastVisible || undefined,
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: !!userData,
  });
  const {
    data: recommendations,
    error,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    isFetching
  } = useInfiniteQuery({
    queryKey: ['products', currentProduct?.id],
    queryFn: async ({ pageParam = 1 }) => {
      try {
        const response = await fetch(`${process.env.REACT_APP_RECOMMENDER}/api/similar/${currentProduct?.id}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            page_number: pageParam,
            items_per_page: 25,
            favCategories: userData?.favCategories || []
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
      } catch (error) {
        console.error('Error fetching similar products:', error);
        showBoundary(error);
        throw error; 
      }
    },
    enabled: !!userData,
    staleTime: Infinity,
    gcTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchInterval: false,

    placeholderData: (previousData) => {
      // Return previous data if available, otherwise return skeleton placeholders
      if (previousData) return previousData;

      return {
        pages: [Array.from({ length: 25 }, (_, index) => ({
          id: `skeleton-${index}`, // Unique ID for each skeleton
          isSkeleton: true, // Flag to identify this as a skeleton placeholder
          name: "Loading...", // Placeholder text
          imageUrl: 'https://dn721803.ca.archive.org/0/items/placeholder-image//placeholder-image.jpg'
        }))],
        pageParams: [1]
      };
    },
    getNextPageParam: (lastPage, allPages) => {
      // If the last page is shorter than the page size, assume it's the last
      return lastPage.length < 24 ? undefined : allPages.length + 1;
    },

  });
  const allShoppingPosts = shoppingPosts?.pages?.flatMap(page => page.posts) || [];
  const allRecommendations = recommendations?.pages?.flat() || [];
  const combinedData = [...allShoppingPosts, ...allRecommendations];
  useEffect(() => {
    if (loadMoreView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
    if (hasNextShoppingPage && !isFetchingNextShoppingPage) {
      fetchNextShoppingPosts();
    }
  }, [loadMoreView]);
  // Temporary image placeholders
  const mainImage = currentProduct?.imageUrl || "https://via.placeholder.com/500x700";
  const secondaryImages = currentProduct?.secondaryImages || [];

  // Handle scroll position saving
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setScrollPosition(currentUrl, scrollTop);
    };

    // Throttle scroll events for better performance
    let ticking = false;
    const throttledScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', throttledScroll);
    return () => window.removeEventListener('scroll', throttledScroll);
  }, [currentUrl, setScrollPosition]);

  // Modified scroll effect that handles both initial load and scroll restoration
  useEffect(() => {
    if (!loading && !isScrollRestored.current) {
      const savedPosition = getPosition(currentUrl);
      
      if (savedPosition > 0) {
        // Restore saved scroll position
        setTimeout(() => {
          window.scrollTo({
            top: savedPosition,
            behavior: 'instant'
          });
          isScrollRestored.current = true;
        });
      } else {
        // Default scroll behavior for new visits
        window.scrollTo({ 
          top: isSmallScreen ? 48 : 0, 
          behavior: "instant" 
        });
        isScrollRestored.current = true;
      }
    }
  }, [loading, currentUrl, getPosition, isSmallScreen]);

  // Reset scroll restoration flag when URL changes
  useEffect(() => {
    isScrollRestored.current = false;
  }, [currentUrl]);


  function getTargetBlockWidth() {
    const screenWidth = window.innerWidth;
    return screenWidth < 440 ? 200 : 230;
  }
  if (loading) {
    return <LoadingSpinner />
  }
  return (
    <div className="px-0" style={{ width: '100%', paddingTop: isSmallScreen ? "0px" : "20px" }}>
      {/* Main Product Row */}
      <div className="d-flex justify-content-between w-100">
        {/* Back Button */}
        {!isSmallScreen && (
          <div>
            <button
              className="btn p-0 d-flex align-items-center"
              onClick={() => window.history.back()}
            >

              <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 13L1 7L7 1" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              <div className='ps-3' style={{ fontFamily: 'Inter', fontWeight: '400', fontSize: '18px', color: '#667085' }}>
                Back
              </div>
            </button>
          </div>
        )}

        {/* Main Image Card - Following ProductCard8 structure */}
        <div className={`${isSmallScreen ? 'card' : 'card'} p-0`}>
          <div className="d-flex flex-column justify-content-between" style={{ padding: isSmallScreen ? "" : "" }}>
            {/* Image Container */}
            <div
              style={{
                position: "relative",
                width: isSmallScreen ? '' : '430px',
                // height: isSmallScreen ? '420px' : "22rem",
              }}
            >
              {/* Back Button Overlay for Small Screens */}
              {isSmallScreen && (
                <button
                  className="btn p-0"
                  onClick={() => window.history.back()}
                  style={{
                    position: 'absolute',
                    top: '10px',
                    left: '0px',
                    zIndex: 10,
                    width: '40px',
                    height: '40px',
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.5 22L11.5 15L18.5 8" stroke="#667085" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              )}

              {/* Image Content */}
              {secondaryImages?.length > 0 ? (
                <div style={{
                  width: "100%",
                  // height: isSmallScreen ? '420px' : "28.875rem",
                  borderRadius: '6px 6px 0px 0px',
                  overflow: 'hidden'
                }}>
                  <Slider {...settings} style={{ width: "100%", height: "100%" }}>
                    {[mainImage, ...secondaryImages]?.map((image, index) => (
                      <div key={index}>
                        <img
                          src={image}
                          style={{
                            width: "100%",
                            // height: "29.875rem",
                            objectFit: "cover",
                            objectPosition: "top",
                          }}
                          alt="Product"
                        />
                      </div>
                    ))}
                  </Slider>
                </div>
              ) : (
                <img
                  src={mainImage}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "top",
                    borderRadius: "6px 6px 0px 0px",
                  }}
                  alt="Product"
                />
              )}

              {/* Add to Favorites - Bottom Right */}
              <div
                className="d-flex align-items-center"
                style={{
                  position: "absolute",
                  bottom: "14px",
                  right: "5px",
                  gap: "2px",
                }}
              >

                <AddToFavorites
                  userId={user?.uid}
                  productId={currentProduct?.id}
                  product={currentProduct}
                  width={32}
                  height={32}
                  borderRadius={4}
                  componentName={'similarProducts'}
                  type={"product"}
                />

              </div>
              {/* /AllProducts/:category/:subCategory/:subSubCategory */}
              {/* Category */}
              <div
                className="d-flex align-items-center"
                style={{
                  position: "absolute",
                  bottom: "14px",
                  left: "5px",
                  gap: "2px",
                }}
              >
                <Link to={`/AllProducts/${currentProduct?.category}/${currentProduct?.subCategory}/${currentProduct?.subSubCategory}`} style={{
                  fontFamily: 'Inter',
                  fontWeight: 400,
                  fontSize: isSmallScreen ? '13px' : '14px',
                  color: '#000000',
                  borderRadius: '4px',
                  padding: isSmallScreen ? '4px 8px' : '4px 8px',
                  backgroundColor: '#F4F9FF',
                  width: 'fit-content',
                  border: '1px solid #676A791A'
                }}>
                  {currentProduct?.subCategory} - {currentProduct?.subSubCategory}
                </Link>
              </div>
            </div>

            {/* Product Details Bottom - Following ProductCard8 structure */}
            <div style={{
              // padding: '2px 2px',
              width: isSmallScreen ? '100vw' : '430px', // Constrain the container width
              // maxWidth: isSmallScreen ? '92vw' : '340px'
            }}>
              {/* Brand Name and Product Name in same line */}
              <div className='p-0 ps-1' style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '2px',
                marginBottom: '2px',
                width: '100%',
                maxWidth: '100%',
                // paddingLeft:'4px'
              }}>
                {/* Brand Name */}
                <div style={{
                  fontFamily: 'Inter',
                  fontWeight: 400,
                  fontSize: '16px',
                  color: '#676A79',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '2px',
                  // textDecoration: 'underline',
                  flexShrink: 0, // Prevents brand name from shrinking
                  width: '100%' // Take full width of container
                }}>
                  <Link to={`/BrandHome/${brandData?.name}`} style={{
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: '16px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: 'calc(100% - 26px)',
                    color: "#676A79",
                  }}>
                    {brandData?.displayName}
                  </Link>
                  <span className='ms-2' style={{
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: '12px', backgroundColor: '#F4F9FF', color: '#000000', cursor: 'pointer', borderRadius: '4px'
                  }}
                    onClick={() => window.open(currentProduct?.url, '_blank')}
                  >
                    <span style={{ padding: '12px' }}>
                      Visit Site



                      <svg width="16" height="16" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_2703_16890)">
                          <path d="M4.14551 10.467L10.0381 4.57448" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M5.56295 4.88327L9.09067 4.30183C9.27517 4.26836 9.45334 4.27268 9.61409 4.31469C9.77485 4.35663 9.91475 4.43529 10.0252 4.54578C10.1357 4.65626 10.2144 4.79616 10.2563 4.95692C10.2983 5.11767 10.3027 5.29584 10.2692 5.48034L9.68774 9.00806" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_2703_16890">
                            <rect width="10" height="10" fill="white" transform="translate(7.07104 14.571) rotate(-135)" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                  </span>
                </div>

                {/* Product Name and Sizes */}
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%',
                  gap: '4px'
                }}>
                  {/* Product Name - Left aligned */}
                  <div style={{
                    fontFamily: 'Inter',
                    fontWeight: 600,
                    fontSize: isSmallScreen ? '20px' : '18px',
                    color: '#000000',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    flex: 1,
                    minWidth: 0
                  }}>
                    {currentProduct?.name}
                  </div>

                  {/* Sizes - Right aligned */}
                  {currentProduct?.sizes?.length > 0 && (
                    <div className="d-flex align-items-center " style={{
                      fontFamily: 'Inter',
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#000000',
                      flexShrink: 0,
                      marginRight: isSmallScreen ? '6px' : '4px'
                    }}>
                      <span style={{
                        fontFamily: 'Inter',
                        fontWeight: 400,
                        fontSize: '14px',
                        color: '#676A79',
                        marginRight: '4px'
                      }}>
                        Sizes:
                      </span>
                      <div className="d-flex flex-wrap gap-1">
                        {currentProduct?.sizes?.map((size, index) => (
                          <div
                            key={index}
                            style={{
                              padding: '2px 4px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            {size}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Price Section */}
              <div className="d-flex align-items-center gap-2 px-1" style={{ marginBottom: '2px' }}>
                {currentProduct?.oldPrice > 0 && (
                  <span style={{
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '18px',
                    color: '#DC2625',
                    textDecoration: 'line-through'
                  }}>
                    PKR {formatPrice(currentProduct?.oldPrice)}
                  </span>
                )}
                {currentProduct?.newPrice && (
                  <span style={{
                    fontFamily: 'Inter',
                    fontWeight: 600,
                    fontSize: '18px',
                    color: '#14191F'
                  }}>
                    PKR {formatPrice(currentProduct?.newPrice)}
                  </span>
                )}

                {currentProduct?.discount > 0 && (
                  <div className="d-flex align-items-center justify-content-center" style={{
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '16px',
                    // padding: isSmallScreen?'':'4px 6px',
                    // backgroundColor: '#DC2625',
                    color: '#005FDA',
                  }}>
                    {currentProduct.discount}% OFF
                  </div>
                )}
              </div>

              {/* Add to List Button */}
              <div
                className="d-flex w-100 "
                style={{ gap: isSmallScreen ? "2px" : "2px", padding: '4px' }}
              >
                <AddToChat3 product={currentProduct} componentName={"SimilarProducts"} />
                <AddToList product={currentProduct} componentName={"SimilarProducts"} />
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>

      {/* Similar Products Grid */}
      <div className="vstack px-lg-0"
        style={{ padding: "8px 4.5px", gap: "4px" }}>

        <div className="row g-1">
          <XMasonry
            center={true}
            responsive={true}
            maxColumns={5}
            targetBlockWidth={getTargetBlockWidth()}
          >
            {combinedData?.map((item, index) => {
              const isSecondLast = index === combinedData?.length - 15;

              if (item?.isShoppingList) {
                return (
                  <XBlock key={`shopping-${item.id + index}`} width={isSmallScreen ? 2 : 1}>
                    <div>
                      <ShoppingListPostCard2 post={item} />
                    </div>
                  </XBlock>
                );
              }
              if ((index + 1) % 9 === 0) {
                return (
                  <XBlock key={`ad-${index}`} width={isSmallScreen ? 2 : 1}>
                    {isSmallScreen ? <GoogleAdCardMobile /> : <GoogleAdCard4 />}
                  </XBlock>
                );
              }
              return (
                <XBlock key={item.id + index} width={1}>
                  {item.isSkeleton ? (
                    <Skeleton />
                  ) : (
                    <div ref={isSecondLast ? loadMoreRef : null}>
                      <ProductCard8 product={item} index={index} />
                    </div>
                  )}
                </XBlock>
              );
            })}
            {isFetchingNextPage &&
              Array.from({ length: 25 }).map((_, index) => (
                <XBlock key={`skeleton-${index}`} width={1}>
                  <Skeleton />
                </XBlock>
              ))}
          </XMasonry>
        </div>

      </div>
    </div>
  );


}

export default SimilarProducts;
